import React, { useState, useEffect } from 'react';
import '../../styles/Pop.css';

function Index() {
    const [pop, setPop] = useState(false);
    const [qrVisible, setQrVisible] = useState(false);

    // Toggle QR visibility when button is clicked
    const toggleQR = () => {
        setQrVisible(!qrVisible);
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY >= 800) {
                setPop(true);
            } else {
                setPop(false);
                setQrVisible(false); // Auto-hide QR if user scrolls back up
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className='pop-wrap'>
            <div className={`pop-container ${pop ? 'active' : ''}`}>
                
                {/* QR Code Drop-up Card */}
                <div className={`qr-dropup ${qrVisible ? 'show' : ''}`}>
                    <p>Scan to join our <br/> Viber Community</p>
                    <img src="/vscimages/ads/sports-viber.jpg" alt="Viber Community QR Code" />
                    <div className="arrow-down"></div>
                </div>

                {/* The Button */}
                <button className="stay-updated-btn" onClick={toggleQR}>
                    {qrVisible ? 'CLOSE' : 'STAY UPDATED!'}
                </button>
                
            </div>
        </div>
    );
}

export default Index;





// import React, {useState} from 'react';
// import { Link } from 'react-router-dom';
// import '../../styles/Pop.css'

// function Index() {

//     const [pop, setPop] = useState(false);

//     const showPop = () => {
//         if(window.scrollY >= 800){
//             setPop(true);
//         }
//         else{
//             setPop(false);
//         }
//     };

//     window.addEventListener('scroll', showPop)

//   return (
//     <>
//         <div className='pop-wrap'>
//             <div className={pop ? 'pop active': 'pop'}>
//                 <Link to="/membership" target="_blank"><button>STAY UPDATED</button></Link>
//             </div>
//         </div>
//     </>
//   )
// }

// export default Index